// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from '@/stores/auth';
import { useSkippedModulesStore } from '@/stores/skippedModules';
import global from '@/global';

// Import your views...
import WelcomeView from '@/views/steps/WelcomeView.vue';
import EToolModuleGuideView from '@/views/steps/EToolModuleGuideView.vue';
// import SelfAssessmentView from '@/views/steps/Fundraising&SustainabilitySelf-AssessmentView.vue';
import TeamMemberView from '@/views/steps/Collaboration&AddingTeamMembersView.vue';
import OverviewAspirationalVision from '@/views/steps/AspirationalVision&MissionOverviewView.vue';
import SocietalChallengeView from '@/views/steps/SocietalChallengeAndOrganizationalSolutionView.vue';
import SocietalImpactView from '@/views/steps/SocietalImpactView.vue';
import MissionStatementView from '@/views/steps/MissionStatementView.vue';
import AspirationalVisionDetailView from '@/views/steps/AspirationalVisionView.vue';
import StrategicPlanningOverviewView from '@/views/steps/StrategicPlanningOverviewView.vue';
import StewardshipOverviewView from '@/views/steps/StewardshipOverviewView.vue';
import FundingAnnualOverviewView from '@/views/steps/FundingAnnualOverviewView.vue';
import CoreAnnualProgramsView from '@/views/steps/CoreAnnualProgramsView.vue';
import CoreAnnualProgramExpensesView from '@/views/steps/CoreAnnualProgramExpensesView.vue';
import FundingAnnualOverheadExpensesView from '@/views/steps/FundingAnnualOverheadExpensesView.vue';
import FundingAnnualRevenueView from '@/views/steps/FundingAnnualRevenueView.vue';

import AnnualFundraisingGoalOverviewView from '@/views/steps/AnnualFundraisingGoalOverviewView.vue';
import BudgetJustificationView from '@/views/steps/BudgetJustificationView.vue';
import FundingAnnualGoalsView from '@/views/steps/FundingAnnualGoalsView.vue';
import StrategyView from '@/views/steps/StrategyView.vue';
import SocietalChangeView from '@/views/steps/SocietalChangeView.vue';
import SolutionView from '@/views/steps/SolutionView.vue';
import ImpactView from '@/views/steps/ImpactView.vue';
import BeneficiariesView from '@/views/steps/BeneficiariesView.vue';
import BenefitsView from '@/views/steps/BenefitsView.vue';
import CoreAnnualProgramEvaluationOverviewView from '@/views/steps/CoreAnnualProgramEvaluationOverviewView.vue';
import MeasuringImpactOutcomesView from '@/views/steps/MeasuringImpactOutcomesView.vue';
import MeasuringImpactOutputsView from '@/views/steps/MeasuringImpactOutputsView.vue';
import AnnualOperatingBudgetSummaryView from '@/views/steps/AnnualOperatingBudgetSummaryView.vue';
import FundingSummaryView from '@/views/steps/FundingSummaryView.vue';
import FundingNewProjectsOverviewView from '@/views/steps/FundingNewProjectsOverviewView.vue';
import NewProjectsView from '@/views/steps/NewProjectsView.vue';
import NewProjectExpensesView from '@/views/steps/NewProjectExpensesView.vue';

import DonorRecognitionAndBenefitStructureView from '@/views/steps/DonorRecognitionAndBenefitStructureView.vue';
import CaseForSupportOverviewView from '@/views/steps/CaseForSupportOverviewView.vue';
import LetterFromExecutiveDirectorView from '@/views/steps/LetterFromExecutiveDirectorView.vue';
import OurStoryView from '@/views/steps/OurStoryView.vue';
import OurVisionView from '@/views/steps/OurVisionView.vue';
import CallForMoreView from '@/views/steps/CallForMoreView.vue';
import AnnualProgramsSummaryView from '@/views/steps/AnnualProgramsSummaryView.vue';
import JoinUsView from '@/views/steps/JoinUsView.vue';
import ImpactStatementView from '@/views/steps/ImpactStatementView.vue';
import WaysToGiveView from '@/views/steps/WaysToGiveView.vue';
import SuccessStoryHighlightsView from '@/views/steps/SuccessStoryHighlightsView.vue';
import FundraisingTalkingPointsView from '@/views/steps/FundraisingTalkingPointsView.vue';
import GiftPyramidOverviewView from '@/views/steps/GiftPyramidOverviewView.vue';
import ProspectToDonorRatioView from '@/views/steps/ProspectToDonorRatioView.vue';
import FundraisingOperationsOverviewView from '@/views/steps/FundraisingOperationsOverviewView.vue';
import PoliciesAndProceduresView from '@/views/steps/PoliciesAndProceduresView.vue';
import DevelopmentDocumentsView from '@/views/steps/DevelopmentDocumentsView.vue';
import CongratulationsCertificateView from '@/views/steps/CongratulationsCertificateView.vue';
import UnderstandingFundraisingResourcesOverviewView from '@/views/steps/UnderstandingFundraisingResourcesOverviewView.vue';
import UnderstandingCaseForSupportView from '@/views/steps/UnderstandingCaseForSupportView.vue';
import UnderstandingStewardshipStructureView from '@/views/steps/UnderstandingStewardshipStructureView.vue';
import CoreProgramExpensesView from '@/views/steps/CoreProgramExpensesView.vue';
import CaseStatementDocumentView from '@/views/steps/CaseStatementDocumentView.vue';
import AnnualFundraisingGoalsView from '@/views/steps/AnnualFundraisingGoalsView.vue';
import CoreProgramEvaluationView from '@/views/steps/CoreProgramEvaluationView.vue';
import NewProjectFundraisingGoalsView from '@/views/steps/NewProjectFundraisingGoalsView.vue';

import StepsView from '@/views/steps/StepsView.vue';
import onboardingWelcomeView from '@/views/steps/onboarding/WelcomeView.vue';
import OnboardingLayout from '@/views/steps/OnboardingLayout.vue';
import OrganizationView from '@/views/steps/onboarding/OrganizationView.vue';
import AboutYouView from '@/views/steps/onboarding/AboutYouView.vue';
import OnboardingSelfAssessmentView from '@/views/steps/onboarding/SelfAssessmentView.vue';
import TeamView from '@/views/steps/onboarding/TeamView.vue';
import LoginView from '@/views/steps/auth/LoginView.vue';
import SignUpView from '@/views/steps/auth/SignUpView.vue';
import ForgotPasswordView from '@/views/steps/auth/ForgotPasswordView.vue';
import ChangePasswordView from '@/views/steps/auth/ChangePasswordView.vue';
import SettingsView from '@/views/SettingsView.vue';
import GettingStartedWelcomeView from '@/views/steps/WelcomeView.vue';
// import FundraisingSustainabilitySelfAssessmentView from '@/views/steps/Fundraising&SustainabilitySelf-AssessmentView.vue';
import CollaborationAddingTeamMembersView from '@/views/steps/Collaboration&AddingTeamMembersView.vue';
import Payment from '@/views/Payment.vue';
import RenewalPayment from '@/views/RenewalPayment.vue';
import RenewalSuccess from '@/views/RenewalSuccess.vue';
import PaymentSuccess from '@/views/PaymentSuccess.vue';
import FundraisingCollateral from '@/views/FundraisingCollateral.vue';
// import ContactView from '../views/ContactView.vue';

// Add helper functions to handle module paths
const formatStepRoute = (path) => {
  const match = path.match(/^\/steps\/([^\/]+)\/([^\/]+)$/);
  if (!match) return null;
  
  const moduleName = match[1];
  const stepName = match[2];
  
  // Convert module name to number
  const moduleMap = {
    'introduction': 1,
    'needs-for-funding': 2,
    'fundraising-landscape': 3,
    'pre-screens': 4,
    'investment-readiness': 5,
    'the-pitch': 6,
    'connecting-and-networking': 7,
    'understanding-term-sheets': 8,
    'funding-new-projects': 9,
    'additional-resources': 10
  };
  
  const moduleNumber = moduleMap[moduleName] || null;
  
  return {
    moduleNumber,
    stepNumber: stepName === 'overview' ? 0 : null
  };
};

const getModuleOverviewPath = (moduleNumber) => {
  const moduleMap = {
    1: '/steps/introduction/overview',
    2: '/steps/needs-for-funding/overview',
    3: '/steps/fundraising-landscape/overview',
    4: '/steps/pre-screens/overview',
    5: '/steps/investment-readiness/overview',
    6: '/steps/the-pitch/overview',
    7: '/steps/connecting-and-networking/overview',
    8: '/steps/understanding-term-sheets/overview',
    9: '/steps/funding-new-projects/overview',
    10: '/steps/additional-resources/overview'
  };
  
  return moduleMap[moduleNumber] || '/steps';
};

// Define allowed paths that can be accessed even when skipped
const allowedSkippedPaths = [
  '/steps/funding-new-projects/overview',
  // Add any other paths that should be accessible even when skipped
];

// Add dynamic routes for core program expenses
const coreProgramRoutes = {
  path: 'funding-annual/program/:programSlug',
  name: 'core-program-expenses',
  component: CoreProgramExpensesView,
  props: true,
  meta: {
    requiresAuth: true,
    requiresNotSkipped: true
  },
  beforeEnter: async (to, from, next) => {
    try {
      // Get core programs from localStorage
      let corePrograms = JSON.parse(localStorage.getItem('corePrograms') || '[]');
      
      // If no programs in localStorage, try to fetch from API
      if (corePrograms.length === 0) {
        const authStore = useAuthStore();
        
        // Wait a bit for auth store to be initialized if needed
        if (!authStore.user?.accessToken) {
          // If no access token, redirect to core programs page
          next('/steps/funding-annual/core-programs');
          return;
        }
        
        try {
          const response = await fetch(`${global.API_URL}/core-programs`, {
            headers: {
              Authorization: `Bearer ${authStore.user.accessToken}`,
            },
          });
          
          if (response.ok) {
            const data = await response.json();
            corePrograms = data.corePrograms || [];
            // Update localStorage with the fetched programs
            localStorage.setItem('corePrograms', JSON.stringify(corePrograms));
          } else {
            // If API call fails, redirect to core programs page
            next('/steps/funding-annual/core-programs');
            return;
          }
        } catch (apiError) {
          console.error('Error fetching core programs:', apiError);
          next('/steps/funding-annual/core-programs');
          return;
        }
      }
      
      // Check if the program exists
      const programExists = corePrograms.some(program => 
        program.program_name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '') === to.params.programSlug
      );
      
      if (!programExists) {
        next('/steps/funding-annual/core-programs');
      } else {
        next();
      }
    } catch (error) {
      console.error('Error in beforeEnter guard:', error);
      next('/steps/funding-annual/core-programs');
    }
  }
};

const routes = [
  {
    path: "/",
    redirect: "/steps/getting-started/welcome"
  },
  {
    path: "/login",
    name: "login",
    component: LoginView,
  },
  {
    path: "/sign-up",
    name: "sign-up",
    component: SignUpView,
  },
  {
    path: "/forgot-password",
    name: "forgot-password",
    component: ForgotPasswordView,
  },
  {
    path: "/new_password",
    name: "new_password",
    component: ChangePasswordView,
  },
  {
    path: "/settings",
    name: "settings",
    component: SettingsView,
  },
  {
    path: '/fundraising-collateral',
    name: 'fundraising-collateral',
    component: FundraisingCollateral,
  },
  {
    path: '/onboarding',
    component: OnboardingLayout,
    children: [
      { path: 'welcome', name: 'welcome', component: onboardingWelcomeView },
      { path: 'organization', name: 'organization', component: OrganizationView },
      { path: 'about-you', name: 'about-you', component: AboutYouView },
      // { path: 'self-assessment', name: 'self-assessment', component: OnboardingSelfAssessmentView },
      { path: 'team', name: 'team', component: TeamView },
    ],
  },
  {
    path: '/steps',
    component: StepsView,
    redirect: '/steps/getting-started/welcome',
    children: [
      {
        path: 'getting-started/welcome',
        name: 'getting-started-welcome',
        component: WelcomeView,
      },
      {
        path: 'getting-started/e-tool-module-guide',
        name: 'getting-started-e-tool-module-guide',
        component: EToolModuleGuideView,
      },
      // {
      //   path: 'getting-started/selfassessment',
      //   name: 'getting-started-selfassessment',
      //   component: SelfAssessmentView,
      // },
      {
        path: 'getting-started/teammember',
        name: 'getting-started-teammember',
        component: TeamMemberView,
      },
      {
        path: 'getting-started/fundraising-resources-overview',
        name: 'getting-started-fundraising-resources-overview',
        component: UnderstandingFundraisingResourcesOverviewView,
      },
      {
        path: 'getting-started/case-for-support',
        name: 'getting-started-case-for-support',
        component: UnderstandingCaseForSupportView,
      },
      {
        path: 'getting-started/stewardship-structure',
        name: 'getting-started-stewardship-structure',
        component: UnderstandingStewardshipStructureView,
      },

      {
        path: 'aspirational-vision/overview',
        name: 'aspirational-vision-overview',
        component: OverviewAspirationalVision,
      },
      {
        path: 'aspirational-vision/societal-challenge',
        name: 'aspirational-vision-societal-challenge',
        component: SocietalChallengeView,
      },
      {
        path: 'aspirational-vision/societal-impact',
        name: 'aspirational-vision-societal-impact',
        component: SocietalImpactView,
      },
      {
        path: 'aspirational-vision/mission-statement',
        name: 'aspirational-vision-mission-statement',
        component: MissionStatementView,
      },
      {
        path: 'aspirational-vision/aspirational-vision',
        name: 'aspirational-vision-detail',
        component: AspirationalVisionDetailView,
      },
      {
        path: 'strategic-planning/overview',
        name: 'strategic-planning-overview',
        component: StrategicPlanningOverviewView,
      },
      {
        path: 'funding-annual/overview',
        name: 'funding-annual-overview',
        component: FundingAnnualOverviewView,
      },
      {
        path: 'funding-annual/core-programs',
        name: 'funding-annual-core-programs',
        component: CoreAnnualProgramsView,
      },
      {
        path: 'funding-annual/core-expenses',
        name: 'funding-annual-core-expenses',
        component: CoreAnnualProgramExpensesView,
      },
      {
        path: 'funding-annual/goals',
        name: 'funding-annual-goals',
        component: FundingAnnualGoalsView,
      },
      {
        path: 'funding-annual/strategy',
        name: 'funding-annual-strategy',
        component: StrategyView,
      },
      {
        path: 'funding-annual/societal-change',
        name: 'funding-annual-societal-change',
        component: SocietalChangeView,
      },
      {
        path: 'funding-annual/solution',
        name: 'funding-annual-solution',
        component: SolutionView,
      },
      {
        path: 'funding-annual/impact',
        name: 'funding-annual-impact',
        component: ImpactView,
      },
      {
        path: 'funding-annual/beneficiaries',
        name: 'funding-annual-beneficiaries',
        component: BeneficiariesView,
      },
      {
        path: 'funding-annual/benefits',
        name: 'funding-annual-benefits',
        component: BenefitsView,
      },
      {
        path: 'finalizing-budget/overview',
        name: 'finalizing-budget-overview',
        component: AnnualFundraisingGoalOverviewView,
      },
      {
        path: 'finalizing-budget/budget-justification',
        name: 'finalizing-budget-budget-justification',
        component: BudgetJustificationView,
      },
      {
        path: 'finalizing-budget/overhead-expenses',
        name: 'finalizing-budget-overhead-expenses',
        component: FundingAnnualOverheadExpensesView,
      },
      {
        path: 'annual-revenue/annual-revenue',
        name: 'annual-revenue-annual-revenue',
        component: FundingAnnualRevenueView,
      },
      {
        path: 'core-program-evaluation/overview',
        name: 'core-program-evaluation-overview',
        component: CoreAnnualProgramEvaluationOverviewView,
      },
      {
        path: 'core-program-evaluation/outcomes',
        name: 'core-program-evaluation-outcomes',
        component: MeasuringImpactOutcomesView,
      },
      {
        path: 'core-program-evaluation/outputs',
        name: 'core-program-evaluation-outputs',
        component: MeasuringImpactOutputsView,
      },
      {
        path: 'annual-operating-budget/summary',
        name: 'annual-operating-budget-summary',
        component: AnnualOperatingBudgetSummaryView,
      },
      {
        path: 'annual-operating-budget/fundraising-goals',
        name: 'annual-operating-budget-fundraising-goals',
        component: AnnualFundraisingGoalsView,
      },
      {
        path: 'funding-new-projects/overview',
        name: 'funding-new-projects-overview',
        component: FundingNewProjectsOverviewView,
        meta: {
          requiresAuth: true,
          requiresNotSkipped: true
        }
      },
      {
        path: 'funding-new-projects/new-projects',
        name: 'funding-new-projects-new-projects',
        component: NewProjectsView,
        meta: {
          requiresAuth: true,
          requiresNotSkipped: true
        }
      },
      {
        path: 'funding-new-projects/new-project-expenses',
        name: 'funding-new-projects-new-project-expenses',
        component: NewProjectExpensesView,
        meta: {
          requiresAuth: true,
          requiresNotSkipped: true
        }
      },

      {
        path: 'funding-new-projects/new-project-fundraising-goals',
        name: 'funding-new-projects-fundraising-goals',
        component: NewProjectFundraisingGoalsView,
        meta: {
          requiresAuth: true,
          requiresNotSkipped: true
        }
      },
      {
        path: 'funding-new-projects/project/:projectSlug',
        name: 'funding-new-projects-project',
        component: () => import('@/views/steps/NewProjectView.vue'),
        meta: {
          requiresAuth: true,
          requiresNotSkipped: true
        }
      },
      {
        path: 'total-fundraising-goal/summary',
        name: 'total-fundraising-goal-summary',
        component: FundingSummaryView,
      },

      {
        path: 'stewardship/overview',
        name: 'stewardship-overview',
        component: StewardshipOverviewView,
      },
      {
        path: 'stewardship/donor-recognition',
        name: 'stewardship-donor-recognition',
        component: DonorRecognitionAndBenefitStructureView,
      },
      {
        path: 'finalize-your-case-for-support/overview',
        name: 'finalize-your-case-for-support-overview',
        component: CaseForSupportOverviewView,
      },
      {
        path: 'finalize-your-case-for-support/letter-from-executive-director',
        name: 'finalize-your-case-for-support-letter-from-executive-director',
        component: LetterFromExecutiveDirectorView,
      },
      {
        path: 'finalize-your-case-for-support/our-story',
        name: 'finalize-your-case-for-support-our-story',
        component: OurStoryView,
      },
      {
        path: 'finalize-your-case-for-support/our-vision',
        name: 'finalize-your-case-for-support-our-vision',
        component: OurVisionView,
      },
      {
        path: 'finalize-your-case-for-support/call-for-more',
        name: 'finalize-your-case-for-support-call-for-more',
        component: CallForMoreView,
      },
      {
        path: 'finalize-your-case-for-support/annual-programs-summary',
        name: 'finalize-your-case-for-support-annual-programs-summary',
        component: AnnualProgramsSummaryView,
      },
      {
        path: 'finalize-your-case-for-support/join-us',
        name: 'finalize-your-case-for-support-join-us',
        component: JoinUsView,
      },
      {
        path: 'finalize-your-case-for-support/ways-to-give',
        name: 'finalize-your-case-for-support-ways-to-give',
        component: WaysToGiveView,
      },
      {
        path: 'finalize-your-case-for-support/impact-statement',
        name: 'finalize-your-case-for-support-impact-statement',
        component: ImpactStatementView,
      },
      {
        path: 'finalize-your-case-for-support/success-story-highlights',
        name: 'finalize-your-case-for-support-success-story-highlights',
        component: SuccessStoryHighlightsView,
      },
      {
        path: 'finalize-your-case-for-support/fundraising-talking-points',
        name: 'finalize-your-case-for-support-fundraising-talking-points',
        component: FundraisingTalkingPointsView,
      },
      {
        path: 'gift-pyramid/overview',
        name: 'gift-pyramid-overview',
        component: GiftPyramidOverviewView,
      },
      {
        path: 'gift-pyramid/prospect-to-donor-ratio',
        name: 'gift-pyramid-prospect-to-donor-ratio',
        component: ProspectToDonorRatioView,
      },
      {
        path: 'fundraising-operations/overview',
        name: 'fundraising-operations-overview',
        component: FundraisingOperationsOverviewView,
      },
      {
        path: 'fundraising-operations/policies-procedures',
        name: 'fundraising-operations-policies-procedures',
        component: PoliciesAndProceduresView,
      },
      {
        path: 'fundraising-operations/development-documents',
        name: 'fundraising-operations-development-documents',
        component: DevelopmentDocumentsView,
      },
      {
        path: 'congratulations/certificate',
        name: 'congratulations-certificate',
        component: CongratulationsCertificateView,
      },
      coreProgramRoutes,
      {
        path: 'core-program-evaluation/program/:slug',
        name: 'core-program-evaluation-program',
        component: CoreProgramEvaluationView,
        props: true,
        meta: {
          requiresAuth: true,
          requiresNotSkipped: true
        },
        beforeEnter: async (to, from, next) => {
          try {
            // Get core programs from localStorage
            let corePrograms = JSON.parse(localStorage.getItem('corePrograms') || '[]');
            
            // If no programs in localStorage, try to fetch from API
            if (corePrograms.length === 0) {
              const authStore = useAuthStore();
              
              // Wait a bit for auth store to be initialized if needed
              if (!authStore.user?.accessToken) {
                // If no access token, redirect to overview page
                next('/steps/core-program-evaluation/overview');
                return;
              }
              
              try {
                const response = await fetch(`${global.API_URL}/core-programs`, {
                  headers: {
                    Authorization: `Bearer ${authStore.user.accessToken}`,
                  },
                });
                
                if (response.ok) {
                  const data = await response.json();
                  corePrograms = data.corePrograms || [];
                  // Update localStorage with the fetched programs
                  localStorage.setItem('corePrograms', JSON.stringify(corePrograms));
                } else {
                  // If API call fails, redirect to overview page
                  next('/steps/core-program-evaluation/overview');
                  return;
                }
              } catch (apiError) {
                console.error('Error fetching core programs:', apiError);
                next('/steps/core-program-evaluation/overview');
                return;
              }
            }
            
            // Check if the program exists
            const programExists = corePrograms.some(program => 
              program.program_name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '') === to.params.slug
            );
            
            if (!programExists) {
              next('/steps/core-program-evaluation/overview');
            } else {
              next();
            }
          } catch (error) {
            console.error('Error in beforeEnter guard:', error);
            next('/steps/core-program-evaluation/overview');
          }
        }
      },
    ],
  },
  {
    path: '/payment',
    name: 'payment',
    component: Payment,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/renewal',
    name: 'renewal-payment',
    component: RenewalPayment,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/subscription/renewal/success',
    name: 'renewal-success',
    component: RenewalSuccess,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/subscription/success',
    name: 'payment-success',
    component: PaymentSuccess,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/case-statement-document',
    name: 'case-statement-document',
    component: CaseStatementDocumentView,
    meta: {
      requiresAuth: true
    }
  },
  // ... other routes
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore();
  const skippedModulesStore = useSkippedModulesStore();

  // On any navigation, check if we need to force refresh skipped modules
  const forceRefreshSkippedModules = localStorage.getItem('forceRefreshSkippedModules');
  if (forceRefreshSkippedModules) {
    await skippedModulesStore.fetchSkippedModules(true);
    localStorage.removeItem('forceRefreshSkippedModules');
  }

  // Check if there's any cached skipped modules data with incorrect naming
  const oldCacheData = localStorage.getItem('skippedModules');
  if (oldCacheData) {
    localStorage.setItem('skipped_modules', oldCacheData);
    localStorage.removeItem('skippedModules');
  }

  try {
    // Fetch or refresh user data on each navigation
    await authStore.fetchUserData();
  } catch (error) {
    console.error("Error fetching user data:", error);
  }

  const isAuthenticated = authStore.user && authStore.user.accessToken;
  const subscriptionStatus = authStore.subscriptionStatus;

  const publicPages = ['/login', '/sign-up', '/forgot-password', '/new_password'];
  const signUpPages = ['/organization-info-s1', '/organization-info-s2', '/payment', '/renewal', '/subscription/renewal/success', '/invitation'];

  const authRequired = !publicPages.includes(to.path);

  if (authRequired && !isAuthenticated) {
    // Store the original URL (including hash) for redirect after login
    const redirectPath = signUpPages.includes(to.path) ? '/sign-up' : '/login';
    const fullPath = to.fullPath; // This includes path, query, and hash
    localStorage.setItem('redirectAfterLogin', fullPath);
    return next(redirectPath);
  }

  // Check if we need to handle unskipped modules for the current route
  const currentPathParts = to.path.split('/');
  let currentModulePath = '';

  // Extract module path from the route (e.g., /steps/fundraising)
  if (currentPathParts.length >= 3) {
    currentModulePath = `/${currentPathParts[1]}/${currentPathParts[2]}`;
    
    // Check for specific module unskip overrides in localStorage
    if (currentModulePath) {
      try {
        const unskippedModulesJson = localStorage.getItem('unskippedModules');
        const unskipTimestamp = localStorage.getItem('unskipTimestamp');
        
        if (unskippedModulesJson && unskipTimestamp) {
          const unskippedModules = JSON.parse(unskippedModulesJson);
          const now = Date.now();
          const fiveMinutesInMs = 5 * 60 * 1000;
          
          // Only apply if unskip is recent (within last 5 minutes)
          if ((now - parseInt(unskipTimestamp)) < fiveMinutesInMs) {
            // Check if this specific module was unskipped
            if (unskippedModules.includes(currentModulePath)) {
              // Force refresh of skipped modules data
              await skippedModulesStore.fetchSkippedModules(true);
              
              // If module is no longer in skipped routes, we don't need to block navigation
              if (!skippedModulesStore.skippedRoutes.includes(currentModulePath)) {
                // Clear old unskip data if it's older than a minute
                if ((now - parseInt(unskipTimestamp)) > 60000) {
                  localStorage.removeItem('unskippedModules');
                  localStorage.removeItem('unskipTimestamp');
                }
                return next(); // Allow navigation
              }
            }
          } else {
            // Clean up expired unskip data
            localStorage.removeItem('unskippedModules');
            localStorage.removeItem('unskipTimestamp');
          }
        }
      } catch (e) {
        // Error handling
      }
    }
  }

  // If the module is skipped, prevent navigation if it's not one of the allowed paths
  if (skippedModulesStore.isRouteSkipped(to.path) && !allowedSkippedPaths.includes(to.path)) {
    const currentStepFormatted = formatStepRoute(to.path);
    
    // Redirect to appropriate overview page
    if (currentStepFormatted) {
      const { moduleNumber, stepNumber } = currentStepFormatted;
      
      // Redirect to overview page for the module instead
      if (moduleNumber !== null) {
        return next({ path: getModuleOverviewPath(moduleNumber) });
      }
    }
    
    // Fallback: redirect to steps overview
    return next({ path: '/steps' });
  }

  // Continue with normal navigation
  next();
});

export default router;